import {dispatch} from '../lib/store';
import {open as openAction, close as closeAction} from '../reducers/modals-info/actions';

const getActiveModal = () => {
    const modal = document.querySelector('.modal-info-container');
    return modal 
}

const open = target => {
    const activeModal = getActiveModal();

    if(activeModal) {
        window.alert(`Active modal exist`);
        return;
    }

    dispatch(openAction(target));
}

const close = () => {
    // Есть ли уже модалка
    const active_modal = getActiveModal(),
          modal = active_modal.querySelector('.modal-info'),
          overlay = active_modal.querySelector('.modal-info-overlay');

    if(active_modal) {
        modal.classList.remove('animate__fadeInUp');
        modal.classList.add('animate__fadeOutDown');
        overlay.classList.remove('animate__fadeIn');
        overlay.classList.add('animate__fadeOut');

        setTimeout(() => {
            dispatch(closeAction());
        }, 500);
    } else {
        dispatch(closeAction());
    }
}

export default {
    open,
    close
}